import { render, staticRenderFns } from "./PMs.vue?vue&type=template&id=58cf6fc0"
import script from "./PMs.vue?vue&type=script&lang=js"
export * from "./PMs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports